var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-4a)" },
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.4571 5.95711C19.8476 5.56658 19.8476 4.93342 19.4571 4.54289C19.0666 4.15237 18.4334 4.15237 18.0429 4.54289L12 10.5858L5.95711 4.54289C5.56658 4.15237 4.93342 4.15237 4.54289 4.54289C4.15237 4.93342 4.15237 5.56658 4.54289 5.95711L10.5858 12L4.54289 18.0429C4.15237 18.4334 4.15237 19.0666 4.54289 19.4571C4.93342 19.8476 5.56658 19.8476 5.95711 19.4571L12 13.4142L18.0429 19.4571C18.4334 19.8476 19.0666 19.8476 19.4571 19.4571C19.8476 19.0666 19.8476 18.4334 19.4571 18.0429L13.4142 12L19.4571 5.95711Z", fill: "#fff" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-4a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })
      )
    )
  );
});